import { getSessionKeyFromUrl, initHintSDK, createReachSDK } from './page-resources';
import { getExchangeUrl, getReachFeature } from './config-resources';
import { clearMessage } from './display';
import type { ExchangeResponse, ExchangeResult } from './types';
export type { ExchangeResult };

/**
 * Exchange session_key for Reach JWT via backend.
 */
export async function exchangeSession(sessionKey: string): Promise<ExchangeResult> {
  const exchangeUrl = getExchangeUrl();
  const res = await fetch(exchangeUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_key: sessionKey }),
  });
  const data = (await res.json()) as ExchangeResponse;
  if (!res.ok) {
    throw new Error(data.error ?? `Exchange failed (${res.status})`);
  }
  if (!data.token || !data.tenant_id) {
    throw new Error('Invalid exchange response');
  }
  return {
    token: data.token,
    tenant_id: data.tenant_id,
    expires_in: data.expires_in ?? 3600,
  };
}

const getToken = async (): Promise<string> => {
  const sessionKey = getSessionKeyFromUrl();
  const result = await exchangeSession(sessionKey);
  return result.token;
};

function renderReachEmbed(token: string): void {
  clearMessage();
  createReachSDK({
    hideFeature: {
      engage: {
        sms: true,
      },
    },
    authToken: token,
    feature: getReachFeature(),
    sandbox: false, // TODO: make configurable for prod
    callbacks: {
      onReauthRequested: getToken,
    },
  });
}

export async function launchReach(): Promise<void> {
  const token = await getToken();
  renderReachEmbed(token);
  initHintSDK();
}
